export let hres72uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_typpayroll',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '55',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'amtreq',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'amtalw',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '70',
      class: 'align-right',
      style: 'min-width: 120px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES72UC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }
  ]

  let tab2TableColumns = [
    {
      key: 'coddcal',
      name: '',
      labelCodapp: 'HRES72UC0',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_coddcal',
      name: '',
      labelCodapp: 'HRES72UC0',
      labelIndex: '40',
      style: 'min-width: 300px;',
      eventName: 'descCoddcal'
    }, {
      key: 'amtreq',
      name: '',
      labelCodapp: 'HRES72UC0',
      labelIndex: '50',
      class: 'align-right',
      style: 'min-width: 200px;',
      summary: true
    }, {
      key: 'amtalw',
      name: '',
      labelCodapp: 'HRES72UC0',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 200px;',
      summary: true
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    },
    th: {
      index: indexColumns,
      detailTab2: tab2TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres72u.js